import { SciLogo } from './SciLogo'

interface AppHeaderProps {
  userName: string | null
  /** Null in development, where there is no session to end. */
  onSignOut: (() => void) | null
}

export function AppHeader({ userName, onSignOut }: AppHeaderProps) {
  return (
    <header className="app-header">
      <SciLogo />
      <div className="app-header__titles">
        <h1 className="app-header__title">Peril Database Search</h1>
        <p className="app-header__user">
          <span>{userName ?? 'Signing you in'}</span>
          {onSignOut ? (
            <button type="button" className="link-button" onClick={onSignOut}>
              Sign out
            </button>
          ) : null}
        </p>
      </div>
    </header>
  )
}
